import { useCallback } from 'react';
import { useTracker } from '@dpdgroupuk/react-event-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { ROUTE_MANAGEMENT } from '../../../constants/analytics';
import modals from '../../../enums/modals';
import { moveSelectedStops } from '../../../store/reducers/route';
import {
  getPreparedStops,
  getSelectedPreparedStops,
} from '../../../store/selectors/ui/routeDetail';

import { wrapPromise } from '../../../utils/promise';
import { useModalContext } from '../../../components/ModalControlled/ModalProvider';

const useMoveToModalData = () => {
  const dispatch = useDispatch();
  const tracker = useTracker();
  const { getModalRef } = useModalContext();
  const preparedStops = useSelector(getPreparedStops);
  const selectedStops = useSelector(getSelectedPreparedStops);

  const openMoveToModal = useCallback(async () => {
    tracker.logEvent(ROUTE_MANAGEMENT.CLICK_MOVE_TO);
    const moveToModalRef = getModalRef(modals.MOVE_TO);
    const [separatorStopNumber, canceled] = await wrapPromise(
      moveToModalRef.current.showModal({
        routeStops: preparedStops,
        selectedStops,
      })
    );

    if (canceled) {
      return;
    }
    dispatch(moveSelectedStops({ separatorStopNumber }));
  }, [tracker, preparedStops, selectedStops, dispatch]);

  return {
    openMoveToModal,
  };
};

export default useMoveToModalData;
